'use client'
import { useEffect, useState } from 'react'
import { useUrlStore } from '@repo/store/useUrlStore'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

const BundledocsBundleSetup = () => {
  const { queryParams } = useUrlStore()
  const [couldNotAutoClose, setCouldNotAutoClose] = useState(false)

  useEffect(() => {

    window.close()

    const fallbackTimer = setTimeout(() => setCouldNotAutoClose(true), 500)
    return () => clearTimeout(fallbackTimer)
  }, [])

  if (!couldNotAutoClose) return null

  const success = queryParams?.success === true || queryParams?.success === 'true'

  return (
    <MUIStack
      data-testid="BundledocsBundleSetup"
      gap={2}
      sx={{ maxWidth: 680, margin: 'auto', backgroundColor: 'white', borderRadius: '6px', padding: '60px 40px' }}
    >
      <MUITypography variant="body1">
        {success
          ? 'Bundledocs authentication was successful. You can close this window.'
          : 'Bundledocs authentication failed. You can close this window and try again.'}
      </MUITypography>
    </MUIStack>
  )
}

export default BundledocsBundleSetup
